import React from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';

//HELPERS
import $ from 'jquery';
import * as c from '../helpers/constants'
import { callApi } from '../helpers/methods'

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { campanhaAction } from '../store/campanha';
import { listaAction } from '../store/lista';

//LAYOUT
import PrivateLayout from '../layouts/private'

//COMPONENTS
import Error404 from '../pages/error404';
import Lista from '../components/campanha/lista';
import ListaDetalhe from '../components/campanha/listaDetalhe';
import ListaUpload from '../components/campanha/listaUpload';
import ListaMapear from '../components/campanha/listaMapear';
import Nova from '../components/campanha/nova';
import NovaEditorHtml from '../components/campanha/novaEditorHtml';
import NovaChecklist from '../components/campanha/novaChecklist';
import Templates from '../components/campanha/templates';
import CamposCampanhaAdesao from '../components/campanha/camposCampanhaAdesao';
import TemplateSMS from '../components/campanha/templateSMS';
import EditarTemplate from '../components/campanha/editarTemplate';
import EditarTemplateSms from '../components/campanha/editarTemplateSms';
import NovaSms from '../components/campanhaSms/novaSms';
import NovaEditorSms from '../components/campanhaSms/novaEditorSms';
import novaChecklistSms from '../components/campanhaSms/novaChecklistSms';
import ListaValidar from '../components/campanha/listaValidar';
import ListaDetalheValidar from '../components/campanha/listaDetalheValidar';
import ListaUploadValidar from '../components/campanha/listaUploadValidar';
import listaMapearValidar from '../components/campanha/listaMapearValidar';
import TemplatesCarimbo from '../components/carimboTempo/templates/template';

class Campanha extends React.PureComponent
{
    constructor(props)
    {
        super(props);
    }

    componentWillReceiveProps(nextProps)
    {
        if (nextProps.campanha.isFinished)
        {
            this.props.actions.campanha.novaCampanha().then((response) => 
            {
                
            }).catch((error) => 
            {
                if (error.message) c.TOASTER(error.type, error.message); else c.TOASTER_ERROR(c.NETWORK_ERROR);
            });     
        }      
        
        if (nextProps.lista.isFinished)
        {
            this.props.actions.lista.novaLista().then((response) => 
            {
                
            }).catch((error) => 
            {
                if (error.message) c.TOASTER(error.type, error.message); else c.TOASTER_ERROR(c.NETWORK_ERROR);
            });     
        } 
    }

    render()
    {
        return (            
            <PrivateLayout navActiveItem={c.NAV_CAMPAIGN}>

                <Switch history={this.props.history}>                           
                    <Redirect exact from={c.CAMPAIGN_ROUTE} to={c.CAMPAIGN_ROUTE+"/lista"} />
                    
                    <Redirect exact from={c.CAMPAIGN_ROUTE+"/lista/criar"} to={this.newListRoute()} />
                    
                    <Route exact path={c.CAMPAIGN_ROUTE+"/lista"} component={Lista} />
                    <Route exact path={c.CAMPAIGN_ROUTE+"/lista/:id([0-9]*)"} component={ListaDetalhe} />   
                    <Route exact path={c.CAMPAIGN_ROUTE+"/lista/upload"} component={ListaUpload} />
                    <Route exact path={c.CAMPAIGN_ROUTE + "/lista/upload/validar"} component={ListaUploadValidar} />
                    <Route exact path={c.CAMPAIGN_ROUTE+"/lista/upload/validar/:id"} component={ListaUploadValidar} />
                    <Route exact path={c.CAMPAIGN_ROUTE+"/lista/validar"} component={ListaValidar} />
                    <Route exact path={c.CAMPAIGN_ROUTE + "/lista/validar/detalhes/:id"} component={ListaDetalheValidar} />   
                    <Route exact path={c.CAMPAIGN_ROUTE+"/lista/validar/importar/mapear"} component={listaMapearValidar} />
                    <Route exact path={c.CAMPAIGN_ROUTE+"/lista/mapear"} component={ListaMapear} />
                
                    <Redirect exact from={c.CAMPAIGN_ROUTE+"/criar"} to={this.newCampaignRoute()} />
                    
                    <Route exact path={c.CAMPAIGN_ROUTE + "/nova"} component={Nova} />
                    <Route exact path={c.CAMPAIGN_ROUTE+"/nova/:id([0-9]*)"} component={Nova} />
                    <Route exact path={c.CAMPAIGN_ROUTE+"/nova/editor-html"} component={NovaEditorHtml} />
                    <Route exact path={c.CAMPAIGN_ROUTE + "/nova/checklist"} component={NovaChecklist} />
                    
                    <Route exact path={c.CAMPAIGN_ROUTE + "/nova-sms"} component={NovaSms} />
                    <Route exact path={c.CAMPAIGN_ROUTE+"/nova-sms/:id([0-9]*)"} component={NovaSms} />
                    <Route exact path={c.CAMPAIGN_ROUTE+"/nova-sms/editor"} component={NovaEditorSms} />
                    <Route exact path={c.CAMPAIGN_ROUTE + "/nova-sms/checklist"} component={novaChecklistSms} />

                    <Route exact path={c.CAMPAIGN_ROUTE + "/templates"} component={Templates} />
                    <Route exact path={c.CAMPAIGN_ROUTE + "/templates/editar-template"} component={EditarTemplate} />
                    <Route exact path={c.CAMPAIGN_ROUTE + "/templates/editar-template/:id([0-9]*)"} component={EditarTemplate} />

                    <Route exact path={c.CAMPAIGN_ROUTE+"/adesao-campos"} component={CamposCampanhaAdesao} />
                    <Route exact path={c.CAMPAIGN_ROUTE + "/template-sms"} component={TemplateSMS} />
                    <Route exact path={c.CAMPAIGN_ROUTE + "/templates-sms/editar-templatesms"} component={EditarTemplateSms} />
                    <Route exact path={c.CAMPAIGN_ROUTE + "/templates-sms/editar-templatesms/:id([0-9]*)"} component={EditarTemplateSms} />

                    <Route component={Error404} />                   
                </Switch>

            </PrivateLayout>
        );
    }  

    newListRoute()
    {
        return c.CAMPAIGN_ROUTE+"/lista/upload";
    }

    newCampaignRoute()
    {
        if (!this.props.campanha.campanha || !this.props.campanha.campanha.isSubmitted)
        {
            return c.CAMPAIGN_ROUTE+"/nova";
        }
        else if (!this.props.campanha.template || !this.props.campanha.template.isSubmitted)
        {
            return c.CAMPAIGN_ROUTE + "/nova/editor-" + this.props.campanha.editor.type;
        }
        else if (this.props.campanha.checklist === undefined || this.props.campanha.isFinished === false)
        {
            return c.CAMPAIGN_ROUTE + "/nova/checklist";
        }
        else
        {
            return c.CAMPAIGN_ROUTE+"/nova";
        }
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth, campanha: state.campanha, lista: state.lista };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { campanha: bindActionCreators(campanhaAction, dispatch), lista: bindActionCreators(listaAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Campanha));
